export const colors = {
  theme: '#111019',
  colorA1: '#FFE03F',
  colorA1Alpha5: 'rgba(255, 224, 63, 0.05)',
  colorA1Alpha80: 'rgba(255, 224, 63, 0.8)',
  colorA2: '#1CEF4B',
  colorA2Alpha10: 'rgba(28, 239, 75, 0.1)',
  colorA3: '#F92B50',
  colorB1: '#fff',
  colorB2: '#BEBDCE',
  colorB3: '#8E8CA0',
  colorB4: '#514F63',
  colorB5: '#232230',
  colorB6: '#1A1924',
  colorB7: '#111019',
  color0: '#FFE03F',
  hoverColor0: '#5543c1',

  color3Alpha5: 'rgba(142, 140, 160, 0.05)',
  color3Alpha8: 'rgba(142, 140, 160, 0.08)',
  hoverColor4: '#807e98',

  color7Alpha5: 'rgba(28, 239, 75, 0.05)',
  color7Alpha8: 'rgba(28, 239, 75, 0.08)',
  color9: '#111019',
  rouletteCard: 'rgba(134, 134, 134, 0.5)',
  colorA4: '#1CFFFB',
  colorA4Alpha10: 'rgba(28, 255, 251, 0.1)',
}
